export default function horizontal_tabs_nav() {
    const tabBlocks = document.querySelectorAll('.horizontal_tabs_block');

    if (!tabBlocks || tabBlocks.length === 0) {
        return;
    }

    tabBlocks.forEach(block => {
        const tabsNavItems = block.querySelectorAll(".horizontal_tabs_nav li");
        const tabsContentItems = block.querySelectorAll(".horizontal_tabs_list li");

        if (!tabsNavItems || !tabsContentItems || tabsNavItems.length === 0 || tabsContentItems.length === 0) {
            return;
        }

        tabsNavItems.forEach(navItem => {
            navItem.addEventListener("click", () => {
                const targetId = navItem.dataset.target;

                tabsNavItems.forEach(item => item.classList.remove("active"));
                tabsContentItems.forEach(item => item.classList.remove("active"));

                navItem.classList.add("active");
                const targetContent = document.getElementById(targetId);
                if (targetContent) {
                    targetContent.classList.add("active");
                }
            });
        });
    });
}
